import cn from 'classnames'

import { OptionType } from '@interfaces/OptionType'
import { SelectButtonProps } from './interface'

export function SelectButton({
  className,
  options,
  value,
  label,
  onChange,
}: SelectButtonProps) {
  return (
    <div className={cn('text-[14px] text-secondary-1')}>
      {label && <div className='font-light text-[12px] mb-[5px]'>{label}</div>}
      <div className={cn('flex', className)}>
        {options.map((option: OptionType, index: number) => (
          <button
            type='button'
            className={cn(
              'flex font-mitr px-[40px] py-[9px] items-center justify-center cursor-pointer rounded-[8px] mobile:w-full',
              {
                'ml-[-4%]': index > 0,
                'bg-secondary dark:bg-purple text-white dark:text-white-2 z-[1] font-medium':
                  value === option.value,
                'bg-gray-4 dark:bg-dark-10 text-secondary-1 dark:text-white-2 font-light':
                  value !== option.value,
              }
            )}
            key={`${option.value}`}
            onClick={() => onChange && onChange(option.value)}
          >
            {option.text}
          </button>
        ))}
      </div>
    </div>
  )
}
